/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-implant-stock.reducer';

export const PharmacyImplantStock = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyImplantStockList = useAppSelector(state => state.pharmacyImplantStock.entities);
  const loading = useAppSelector(state => state.pharmacyImplantStock.loading);
  const totalItems = useAppSelector(state => state.pharmacyImplantStock.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-implant-stock-heading" data-cy="PharmacyImplantStockHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.home.title">Pharmacy Implant Stocks</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-implant-stock/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.home.createLabel">Create new Pharmacy Implant Stock</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyImplantStock.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyImplantStockList && pharmacyImplantStockList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('brandId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.brandId">Brand Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('brandId')} />
                </th>
                <th className="hand" onClick={sort('stockQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.stockQty">Stock Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('stockQty')} />
                </th>
                <th className="hand" onClick={sort('manufacDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.manufacDate">Manufac Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('manufacDate')} />
                </th>
                <th className="hand" onClick={sort('expDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.expDate">Exp Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expDate')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('batchNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.batchNumber">Batch Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('batchNumber')} />
                </th>
                <th className="hand" onClick={sort('taxCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.taxCode">Tax Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('taxCode')} />
                </th>
                <th className="hand" onClick={sort('mrp')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.mrp">Mrp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mrp')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th className="hand" onClick={sort('remainingQuantity')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.remainingQuantity">Remaining Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remainingQuantity')} />
                </th>
                <th className="hand" onClick={sort('serialNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.serialNumber">Serial Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('serialNumber')} />
                </th>
                <th className="hand" onClick={sort('packs')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.packs">Packs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('packs')} />
                </th>
                <th className="hand" onClick={sort('HSNCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.HSNCode">HSN Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('HSNCode')} />
                </th>
                <th className="hand" onClick={sort('rack')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.rack">Rack</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rack')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('available')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.available">Available</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('available')} />
                </th>
                <th className="hand" onClick={sort('internal')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.internal">Internal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('internal')} />
                </th>
                <th className="hand" onClick={sort('shipmentItemId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.shipmentItemId">Shipment Item Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('shipmentItemId')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('margin')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.margin">Margin</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin')} />
                </th>
                <th className="hand" onClick={sort('cessAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.cessAmount">Cess Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cessAmount')} />
                </th>
                <th className="hand" onClick={sort('exempted')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.exempted">Exempted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exempted')} />
                </th>
                <th className="hand" onClick={sort('importDuty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.importDuty">Import Duty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('importDuty')} />
                </th>
                <th className="hand" onClick={sort('freeQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.freeQty">Free Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('freeQty')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.pharmacy">Pharmacy</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.implant">Implant</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.supplier">Supplier</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.bill">Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.uqcType">Uqc Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyImplantStockList.map((pharmacyImplantStock, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-implant-stock/${pharmacyImplantStock.id}`} color="link" size="sm">
                      {pharmacyImplantStock.id}
                    </Button>
                  </td>
                  <td>{pharmacyImplantStock.brandId}</td>
                  <td>{pharmacyImplantStock.stockQty}</td>
                  <td>{pharmacyImplantStock.manufacDate}</td>
                  <td>{pharmacyImplantStock.expDate}</td>
                  <td>{pharmacyImplantStock.timestampentry}</td>
                  <td>{pharmacyImplantStock.microSec}</td>
                  <td>{pharmacyImplantStock.lastupdated}</td>
                  <td>{pharmacyImplantStock.active ? 'true' : 'false'}</td>
                  <td>{pharmacyImplantStock.cursor}</td>
                  <td>{pharmacyImplantStock.batchNumber}</td>
                  <td>{pharmacyImplantStock.taxCode}</td>
                  <td>{pharmacyImplantStock.mrp}</td>
                  <td>{pharmacyImplantStock.price}</td>
                  <td>{pharmacyImplantStock.remainingQuantity}</td>
                  <td>{pharmacyImplantStock.serialNumber}</td>
                  <td>{pharmacyImplantStock.packs}</td>
                  <td>{pharmacyImplantStock.HSNCode}</td>
                  <td>{pharmacyImplantStock.rack}</td>
                  <td>{pharmacyImplantStock.discount}</td>
                  <td>{pharmacyImplantStock.available ? 'true' : 'false'}</td>
                  <td>{pharmacyImplantStock.internal ? 'true' : 'false'}</td>
                  <td>{pharmacyImplantStock.shipmentItemId}</td>
                  <td>{pharmacyImplantStock.addedById}</td>
                  <td>{pharmacyImplantStock.modifiedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyImplantStock.addedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyImplantStock.modifiedByType}`} />
                  </td>
                  <td>{pharmacyImplantStock.margin}</td>
                  <td>{pharmacyImplantStock.cessAmount}</td>
                  <td>{pharmacyImplantStock.exempted ? 'true' : 'false'}</td>
                  <td>{pharmacyImplantStock.importDuty}</td>
                  <td>{pharmacyImplantStock.freeQty}</td>
                  <td>
                    {pharmacyImplantStock.pharmacy ? (
                      <Link to={`/pharmacy/${pharmacyImplantStock.pharmacy.id}`}>{pharmacyImplantStock.pharmacy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyImplantStock.implant ? (
                      <Link to={`/implant/${pharmacyImplantStock.implant.id}`}>{pharmacyImplantStock.implant.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyImplantStock.supplier ? (
                      <Link to={`/pharmacy-suppliers/${pharmacyImplantStock.supplier.id}`}>{pharmacyImplantStock.supplier.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyImplantStock.bill ? (
                      <Link to={`/pharmacy-stock-bill/${pharmacyImplantStock.bill.id}`}>{pharmacyImplantStock.bill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyImplantStock.uqcType ? (
                      <Link to={`/clinical-dictionary/${pharmacyImplantStock.uqcType.id}`}>{pharmacyImplantStock.uqcType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-implant-stock/${pharmacyImplantStock.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-implant-stock/${pharmacyImplantStock.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-implant-stock/${pharmacyImplantStock.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.home.notFound">No Pharmacy Implant Stocks found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyImplantStockList && pharmacyImplantStockList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyImplantStock;
